// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.active[data-v-76b95009] {\n  box-shadow: 0px 2px 10px 3px rgba(120,120,120,0.75);\n  background: #385F73;\n  color: white !important;\n}\n.edit-menu-container[data-v-76b95009] {\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: flex-start;\n  grid-column-gap: 0px;\n  position: relative;\n}\n.qty-controls[data-v-76b95009] {\n  display: grid; \n  width: 100%; \n  max-width: 100px; \n  grid-template-columns: auto 50px auto; \n  justify-content: flex-center;\n}\n", ""]);
// Exports
module.exports = exports;
